import {REHYDRATE} from 'redux-persist';

import {unexpectedCase} from 'nutshell-core/reducer-utils';

import {ActionTypes} from './glossary-actions';
import type {GlossaryAction} from './glossary-actions';

export type GlossaryState = {
    glossaryKey: string | null | undefined;
    isButtonExpanded: boolean;
};

export const defaultGlossaryState = {
    glossaryKey: null,
    isButtonExpanded: false,
} as const;

export const glossaryReducer = (
    state: GlossaryState | null | undefined = defaultGlossaryState,
    action: GlossaryAction
): GlossaryState => {
    switch (action.type) {
        case ActionTypes.SIDEBAR_OPENED:
            // @ts-expect-error
            return {
                ...state,
                glossaryKey: action.payload.glossaryKey,
            };
        case ActionTypes.SIDEBAR_CLOSED:
            return defaultGlossaryState;
        case ActionTypes.GLOSSARY_BUTTON_TOGGLE:
            // @ts-expect-error
            return {
                ...state,
                isButtonExpanded: action.payload.isExpanded,
            };
        // @ts-expect-error
        case REHYDRATE: {
            // @ts-expect-error
            const persistedState = action.payload;
            if (!persistedState || !persistedState.ui || !persistedState.ui.glossary) {
                // @ts-expect-error
                return state;
            }

            return persistedState.ui.glossary;
        }
        default:
            // @ts-expect-error
            unexpectedCase(action.type);

            // @ts-expect-error
            return state;
    }
};
